import { connect } from 'react-redux';
import CraftEmail from './CraftEmail';
import shareEstimateAction from '../../../actions/shareEstimate';
import saveDCSignature from '../../../actions/saveDCSignature';
import config from '../../../helpers/config';

const mapStateToProps = ({ estimateBuilder }) => {
  const { share, entities } = estimateBuilder;
  const shareUrl = `${config.baseUrl}${config.estimatebuilderBasePath}${config.estimatebuilderLoadPath}/${share.selection.join()}`;

  const estimateNames = share.selection.map(givenId => entities.estimates.byId[givenId].name);

  const { signature } = share;

  return {
    selection: share.selection,
    estimateNames,
    shareUrl,
    signature: signature || {
      name: '',
      email: '',
      phone: '',
      extension: '',
    },
  };
};

const mapDispatchToProps = {
  shareEstimateAction,
  saveDCSignature,
};

export default connect(mapStateToProps, mapDispatchToProps)(CraftEmail);
